export default "__VITE_ASSET__tu6kE1mX__"